import { z } from 'zod/v4';

/** Per-file style match from the AI worker (may be zero, one, or many per file). */
export const ProductDocumentResultFileStyleSchema = z.object({
  comment: z.string().optional(),
  styleId: z.string(),
  styleName: z.string().optional(),
  matchSource: z.string().optional(),
  matchContent: z.string().optional(),
  matchConfidence: z.number().optional(),
});

/** A single file's outcome as reported by the tracing-ai worker over AMQP. */
export const ProductDocumentResultFileSchema = z.object({
  fileId: z.string(),
  fileName: z.string(),
  styleMatch: z.boolean(),
  styles: z.array(ProductDocumentResultFileStyleSchema),
  documentType: z.string().optional(),
  documentTypeConfidence: z.number().min(0).max(1).optional(),
});

/** Batch envelope for a request's per-file AI results. Retained for external
 *  callers and the `ProductDocumentResultsMessageType` type — no runtime path
 *  publishes or consumes it anymore. */
export const ProductDocumentResultsMessageSchema = z.object({
  analysisId: z.string(),
  companyId: z.string(),
  files: z.array(ProductDocumentResultFileSchema),
});

export type ProductDocumentResultFileStyleType = z.infer<
  typeof ProductDocumentResultFileStyleSchema
>;
export type ProductDocumentResultFileType = z.infer<
  typeof ProductDocumentResultFileSchema
>;
export type ProductDocumentResultsMessageType = z.infer<
  typeof ProductDocumentResultsMessageSchema
>;
